"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[590],{

/***/ 7590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SortDropdown": function() { return /* binding */ SortDropdown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5034);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(169);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2050);
/* harmony import */ var theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(863);
/* harmony import */ var theme_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2680);
/* harmony import */ var _snippets__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3971);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4174);
/* harmony import */ var _Sort_theme__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2283);








var SortDropdown = (0,_Sort_theme__WEBPACK_IMPORTED_MODULE_3__/* .themed */ .H)(function(param) {
    var theme = param.theme;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useCollectionSort */ .$t)(), 2), sortOptions = ref[0].sortOptions, sortCollection = ref[1].sortCollection;
    return (sortOptions === null || sortOptions === void 0 ? void 0 : sortOptions.length) ? /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_snippets__WEBPACK_IMPORTED_MODULE_1__/* .Dropdown */ .Lt, {
        "data-comp": SortDropdown.displayName,
        initial: sortOptions[0],
        onSelected: function(param) {
            var field = param.field, direction = param.direction;
            return sortCollection({
                field: field,
                direction: direction
            });
        },
        sx: theme.dropdown,
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_snippets__WEBPACK_IMPORTED_MODULE_1__/* .Dropdown.Selected */ .Lt.Selected, {
                sx: theme.selected,
                children: function(param) {
                    var selecting = param.selecting, selected = param.selected;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(theme_ui__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, {
                        sx: theme.selected.content,
                        children: [
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(theme_ui__WEBPACK_IMPORTED_MODULE_5__/* .Paragraph */ .nv, {
                                sx: theme.selected.title,
                                children: [
                                    /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("strong", {
                                        children: "Sort By:"
                                    }),
                                    " ",
                                    selected === null || selected === void 0 ? void 0 : selected.label
                                ]
                            }),
                            /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_snippets__WEBPACK_IMPORTED_MODULE_1__/* .Svg */ .ny, {
                                alt: "chevron",
                                viewBox: "0 0 16 16",
                                src: "/svgs/chevron/down.svg#down",
                                sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, theme.selected.icon), {
                                    transform: selecting ? "rotate(180deg)" : "rotate(0deg)"
                                })
                            })
                        ]
                    });
                }
            }),
            sortOptions.map(function(item, index) {
                return /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_snippets__WEBPACK_IMPORTED_MODULE_1__/* .Dropdown.Option */ .Lt.Option, {
                    option: item,
                    sx: theme.option,
                    children: function(param) {
                        var selecting = param.selecting, isSelected = param.isSelected, option = param.option;
                        return isSelected ? null : /*#__PURE__*/ (0,theme_ui_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(theme_ui__WEBPACK_IMPORTED_MODULE_5__/* .Paragraph */ .nv, {
                            sx: theme.option.title,
                            children: option.label
                        });
                    }
                }, item.label);
            })
        ]
    }) : null;
});
SortDropdown.displayName = "SortDropdown";


/***/ })

}]);